<template>
  <v-container grid-list-md class="py-0 px-2 ma-0">
    <v-row>
      <v-col cols="12">
        <v-flex xs12 v-if="lAction === 'view'">
          <v-layout row wrap>
            <v-flex xs12>
              <span class="body-1 font-weight-bold primary--text">Sales Department Configuration</span>
            </v-flex>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-card @click="loadCatSubCatForSalesReviewPage()">
                    <v-card-title class="subtitle-2 pa-2 grey lighten-4">
                      Sales Review Questionnaire Configuration
                    </v-card-title>
                    <v-card-text class="pt-2">
                      Add or Delete Sales Review Questionnaire Configuration
                      <div style="float:right">
                        <v-icon>mdi-chevron-right</v-icon>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-card @click="loadVoiceOfCustomerConfig()">
                    <v-card-title class="subtitle-2 pa-2 grey lighten-4">
                      Voice Of Customer Questionnaire Configuration
                    </v-card-title>
                    <v-card-text class="pt-2">
                      Add or Delete Voice Of Customer Configuration
                      <div style="float:right">
                        <v-icon>mdi-chevron-right</v-icon>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-card @click="loadCustomerExpectationConfig()">
                    <v-card-title class="subtitle-2 pa-2 grey lighten-4">
                      Customer Expectations Configuration
                    </v-card-title>
                    <v-card-text class="pt-2">
                      Add or Delete Customer Expectations Configuration
                      <div style="float:right">
                        <v-icon>mdi-chevron-right</v-icon>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-card @click="loadUniserviceCommitmentsConfig()">
                    <v-card-title class="subtitle-2 pa-2 grey lighten-4">
                      Uniservice Commitments Configuration
                    </v-card-title>
                    <v-card-text class="pt-2">
                      Add or Delete Uniservice Commitments Configuration
                      <div style="float:right">
                        <v-icon>mdi-chevron-right</v-icon>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 class="pt-3" v-if="lAction === 'view'">
          <v-layout row wrap>
            <v-flex xs12>
              <span class="body-1 font-weight-bold primary--text">Onboarding Department Configuration</span>
            </v-flex>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-card @click="loadCatSubCatForOnboardingReviewPage()">
                    <v-card-title class="subtitle-2 pa-2 grey lighten-4">
                      Onboarding Planner Configuration
                    </v-card-title>
                    <v-card-text class="pt-2">
                      Add or Delete Onboarding Planner Configuration
                      <div style="float:right">
                        <v-icon>mdi-chevron-right</v-icon>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-card @click="loadResourceResponsibilty()">
                    <v-card-title class="subtitle-2 pa-2 grey lighten-4">
                      Resource Resonsibility Configuration
                    </v-card-title>
                    <v-card-text class="pt-2">
                      Add or Delete Resource Responsibility Configuration
                      <div style="float:right">
                        <v-icon>mdi-chevron-right</v-icon>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 class="pt-3" v-if="lAction === 'view'">
          <v-layout row wrap>
            <v-flex xs12>
              <span class="body-1 font-weight-bold primary--text">Deboarding Configuration</span>
            </v-flex>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-card @click="loadCatSubCatForDeboardingReviewPage()">
                    <v-card-title class="subtitle-2 pa-2 grey lighten-4">
                      Deboarding Planner Configuration
                    </v-card-title>
                    <v-card-text class="pt-2">
                      Add or Delete Deboarding Planner Configuration
                      <div style="float:right">
                        <v-icon>mdi-chevron-right</v-icon>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>

        <!-- plus btn -->
        <v-btn dark fab fixed v-if="lAction !== 'view' && lAction !== 'resource' && (config.IS_EDITED_BY_USER)"
        :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; left:330px;':'bottom:15px; right:15px;')"
        color="accent"
        @click.native="lAction === 'sales' ? prepareCreateSales() : lAction === 'voice-of-customer' ? prepareCreateVoiceofCust() : lAction === 'customer-expectation' ? prepareCreateCustExpect() : lAction === 'uniservice-commit' ? prepareCreateUniCommit() : lAction === 'onboarding' ? prepareCreateOnboarding() : lAction === 'deboarding' ? prepareCreateDeboarding() : ''">
          <v-icon small>mdi-plus</v-icon>
        </v-btn>

        <!-- sales config -->
        <v-container class="pa-0" v-if="lAction === 'sales'" grid-list-md>
          <v-flex xs12>
            <v-card>
              <v-card-title class="primary--text py-2 grey lighten-4">
                <v-btn class="mr-2" small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
                Sales Review Questionnaire Configuration
              </v-card-title>
              <v-card-text class="pt-1">
                <v-expansion-panels class="pt-2" :value="selTab">
                  <v-expansion-panel class="pa-1" v-for="(cat, i) in salesCat" :key="i">
                    <v-expansion-panel-header style="min-height: 42px" class="pt-2 grey lighten-4 font-weight-bold">
                      {{cat.mi_sales_cat}}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="pt-2">
                      <v-flex xs12>
                        <v-data-table
                        :headers="salesReviewPageHeader"
                        :items="salesReviewPageItem.filter(rec => rec.mi_sales_cat_id === cat.mi_sales_cat_id)"
                        disable-pagination
                        dense
                        hide-default-header
                        hide-default-footer
                        class="elevation-3"
                        :mobile-breakpoint="0">
                          <template v-slot:header="{ props: { headers } }">
                            <thead>
                              <tr>
                                <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 50px; text-align: left;">{{headers[0].text}}</th>
                                <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 400px; text-align: left;">{{headers[1].text}}</th>
                              </tr>
                            </thead>
                          </template>
                          <template slot="item" slot-scope="props">
                            <tr @click="prepareUpdateSalesSubCat(props.item)">
                              <td style="font-size: 13px;">{{ props.item.sno }}</td>
                              <td style="font-size: 13px;">{{ props.item.mi_sales_sub_cat ? props.item.mi_sales_sub_cat : ' ' }}</td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-container>

        <!-- Add or update sales sub dategory -->
        <v-dialog v-model="showSales" persistent max-width="500px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lForm" @submit.prevent="saveSalesChanges(lSales.action)">
                <v-card scrollable>
                  <v-card-title class="title grey lighten-4 py-2">
                    {{lSales.action === 'create-sale-subcat' ? 'Create' : 'Update'}} Sales Review Item
                    <v-spacer></v-spacer>
                    <v-btn icon small @click.stop="showSales = false"><v-icon>mdi-close</v-icon></v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs8 class="pt-4">
                        <v-autocomplete
                        v-model="lSales.mi_sales_cat_id"
                        :items="salesCat"
                        item-value="mi_sales_cat_id"
                        item-text="mi_sales_cat"
                        label="Sales Category"
                        dense
                        hide-details
                        :rules="[rules.required]"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs4 class="pt-4">
                        <v-btn small @click="showSalesCat = true">Add Category</v-btn>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lSales.mi_sales_sub_cat"
                        label="Sales Sub Category"
                        hide-details
                        maxlength="250"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-btn v-if="lSales.action !== 'create-sale-subcat' && (config.IS_EDITED_BY_USER)" @click="deleteSalesChanges('delete-sale-subcat')">delete</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn type="submit" color="accent" v-if="(config.IS_EDITED_BY_USER)">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- List of sales Category -->
        <v-dialog v-model="showSalesCat" persistent max-width="500px">
          <v-flex xs12>
            <v-card>
              <v-card-title class="grey lighten-4 py-2">
                Sales Review Category
                <v-spacer></v-spacer>
                <v-btn icon small @click="showSalesCat = false"><v-icon>mdi-close</v-icon></v-btn>
              </v-card-title>
              <v-card-text>
                <v-flex xs12 class="text-right py-2">
                  <v-btn small class="accent" @click="prepareSalesCat()">Add New</v-btn>
                </v-flex>
                <v-data-table
                :headers="salesCatHeader"
                :items="salesCat"
                disable-pagination
                hide-default-footer
                dense
                class="elevation-3"
                :mobile-breakpoint="0">
                  <template slot="item" slot-scope="props">
                    <tr @click="updateSalesCategory(props.item)">
                      <td style="font-size: 13px;">{{ props.item.mi_sales_cat ? props.item.mi_sales_cat : ' ' }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-dialog>

        <!-- Add or update sale category -->
        <v-dialog v-model="showSalesCateditorupdate" persistent max-width="500px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lForm" @submit.prevent="saveSalesCatChanges(lSalesCat.action)">
                <v-card scrollable>
                  <v-card-title class="title grey lighten-4 py-2">
                    {{lSalesCat.action === 'create-sale-cat' ? 'Create' : 'Update'}} Sales Review Category
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lSalesCat.mi_sales_cat"
                        label="Sales Category"
                        hide-details
                        maxlength="100"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-btn v-if="lSales.action !== 'create-sale-cat' && (config.IS_EDITED_BY_USER)" @click="deleteSalesCatChanges('delete-sale-cat')">delete</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click.stop="showSalesCateditorupdate = false">Cancel</v-btn>
                    <v-btn type="submit" color="accent" v-if="(config.IS_EDITED_BY_USER)">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- Voice of customer config -->
        <v-container class="pa-0" v-if="lAction === 'voice-of-customer'" grid-list-md>
          <v-flex xs12>
            <v-card>
              <v-card-title class="primary--text py-2 grey lighten-4">
                <v-btn class="mr-2" small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
                Voice of Customer Questionnaire Configuration
              </v-card-title>
              <v-card-text class="pt-3">
                <v-flex xs12>
                  <v-data-table
                  :headers="voiceOfCustomerHeader"
                  :items="voiceOfCustomerItem"
                  disable-pagination
                  hide-default-header
                  hide-default-footer
                  class="elevation-3"
                  dense
                  :mobile-breakpoint="0">
                    <template v-slot:header="{ props: { headers } }">
                      <thead>
                        <tr>
                          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 50px; text-align: left;">{{headers[0].text}}</th>
                          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 400px; text-align: left;">{{headers[1].text}}</th>
                        </tr>
                      </thead>
                    </template>
                    <template slot="item" slot-scope="props">
                      <tr @click="prepareUpdateVoice(props.item)">
                        <td style="font-size: 13px;">{{ props.item.sno }}</td>
                        <td style="font-size: 13px;">{{ props.item.mi_voice_of_cust ? props.item.mi_voice_of_cust : ' ' }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-container>

        <!-- Add or update Voice of customer -->
        <v-dialog v-model="showVoice" persistent max-width="500px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lForm" @submit.prevent="saveVoiceChanges(lVoice.action)">
                <v-card scrollable>
                  <v-card-title class="title grey lighten-4 py-2">
                    {{lVoice.action === 'create-voice' ? 'Create' : 'Update'}} Voice of Customer
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lVoice.mi_voice_of_cust"
                        label="Voice of Customer Questions"
                        hide-details
                        maxlength="250"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-btn v-if="lVoice.action !== 'create-voice' && (config.IS_EDITED_BY_USER)" @click="deleteVoiceChanges('delete-voice')">delete</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click.stop="showVoice = false">Cancel</v-btn>
                    <v-btn type="submit" color="accent" v-if="(config.IS_EDITED_BY_USER)">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- Customer Expectations config -->
        <v-container class="pa-0" v-if="lAction === 'customer-expectation'" grid-list-md>
          <v-flex xs12>
            <v-card>
              <v-card-title class="primary--text py-2 grey lighten-4">
                <v-btn class="mr-2" small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
                Customer Expectations Configuration
              </v-card-title>
              <v-card-text class="pt-3">
                <v-flex xs12>
                  <v-data-table
                  :headers="customerExpectationHeader"
                  :items="customerExpectationItem"
                  disable-pagination
                  hide-default-header
                  hide-default-footer
                  class="elevation-3"
                  dense
                  :mobile-breakpoint="0">
                    <template v-slot:header="{ props: { headers } }">
                      <thead>
                        <tr>
                          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 50px; text-align: left;">{{headers[0].text}}</th>
                          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[1].text}}</th>
                          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 300px; text-align: left;">{{headers[2].text}}</th>
                          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 80px; text-align: left;">{{headers[3].text}}</th>
                        </tr>
                      </thead>
                    </template>
                    <template slot="item" slot-scope="props">
                      <tr @click="prepareUpdateCust(props.item)">
                        <td style="font-size: 13px;">{{ props.item.sno }}</td>
                        <td style="font-size: 13px;">{{ props.item.category ? props.item.category : ' ' }}</td>
                        <td style="font-size: 13px;">{{ props.item.mi_cust_expect ? props.item.mi_cust_expect : ' ' }}</td>
                        <td style="font-size: 13px;">{{ props.item.mi_freq ? props.item.mi_freq : ' ' }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-container>

        <!-- Add or update customer expectation -->
        <v-dialog v-model="showCust" persistent max-width="500px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lForm" @submit.prevent="saveCustChanges(lCust.action)">
                <v-card scrollable>
                  <v-card-title class="title grey lighten-4 py-2">
                    {{lCust.action === 'create-cust' ? 'Create' : 'Update'}} Customer Expectation
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 class="pt-4">
                        <v-autocomplete
                        v-model="lCust.category"
                        label="Category"
                        :items="['MANAGEMENT/OFFICE', 'TECHNICAL SERVICES', 'SOFT SERVICES', 'SAFTY/SECURITY', 'OTHERS']"
                        hide-details
                        dense
                        :rules="[rules.required]"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lCust.mi_cust_expect"
                        label="Customer Expectation Description"
                        hide-details
                        maxlength="250"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs8 class="pt-4">
                        <v-autocomplete
                        v-model="lCust.mi_freq_id"
                        :items="freqItem"
                        item-value="mi_freq_id"
                        item-text="mi_freq"
                        label="Frequency"
                        dense
                        hide-details
                        :rules="[rules.required]"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs4 class="pt-4">
                        <v-btn small @click="loadListFrequency()">Add Frequency</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-btn v-if="lCust.action !== 'create-cust' && (config.IS_EDITED_BY_USER)" @click="deleteCustChanges('delete-cust')">delete</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click.stop="showCust = false">Cancel</v-btn>
                    <v-btn type="submit" color="accent" v-if="(config.IS_EDITED_BY_USER)">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- List of Frequency -->
        <v-dialog v-model="showListofCustFreq" persistent max-width="500px">
          <v-flex xs12>
            <v-card>
              <v-card-title class="grey lighten-4 py-2">
                List of Frequency
                <v-spacer></v-spacer>
                <v-btn icon small @click="showListofCustFreq = false"><v-icon>mdi-close</v-icon></v-btn>
              </v-card-title>
              <v-card-text>
                <v-flex xs12 class="text-right py-2">
                  <v-btn small class="accent" @click="prepareCreateFrequency()">Add New</v-btn>
                </v-flex>
                <v-data-table
                :headers="freqHeader"
                :items="freqItem"
                disable-pagination
                hide-default-footer
                class="elevation-3"
                dense
                :mobile-breakpoint="0">
                  <template slot="item" slot-scope="props">
                    <tr @click="prepareUpdateFrequency(props.item)">
                      <td style="font-size: 13px;">{{ props.item.mi_freq ? props.item.mi_freq : ' ' }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-dialog>

        <!-- create/update/delete Frequency -->
        <v-dialog v-model="showCustFreq" persistent max-width="500px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lForm" @submit.prevent="saveFreqChanges(lCustFreq.action)">
                <v-card scrollable>
                  <v-card-title class="title grey lighten-4 py-2">
                    {{lCustFreq.action === 'create-custFreq' ? 'Create' : 'Update'}} Frequency
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lCustFreq.mi_freq"
                        label="Frequency"
                        hide-details
                        maxlength="50"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-btn v-if="lCustFreq.action !== 'create-custFreq' && (config.IS_EDITED_BY_USER)" @click="deleteFreqChanges('delete-custFreq')">delete</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click.stop="showCustFreq = false">Cancel</v-btn>
                    <v-btn type="submit" color="accent" v-if="(config.IS_EDITED_BY_USER)">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- Uniservice Commitment config -->
        <v-container class="pa-0" v-if="lAction === 'uniservice-commit'" grid-list-md>
          <v-flex xs12>
            <v-card>
              <v-card-title class="primary--text py-2 grey lighten-4">
                <v-btn class="mr-2" small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
                Uniservice Commitment Configuration
              </v-card-title>
              <v-card-text class="pt-3">
                <v-flex xs12>
                  <v-data-table
                  :headers="uniserviceCommitHeader"
                  :items="uniserviceCommitItem"
                  disable-pagination
                  hide-default-header
                  hide-default-footer
                  class="elevation-3"
                  dense
                  :mobile-breakpoint="0">
                    <template v-slot:header="{ props: { headers } }">
                      <thead>
                        <tr>
                          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 50px; text-align: left;">{{headers[0].text}}</th>
                          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[1].text}}</th>
                          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 300px; text-align: left;">{{headers[2].text}}</th>
                          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 80px; text-align: left;">{{headers[3].text}}</th>
                        </tr>
                      </thead>
                    </template>
                    <template slot="item" slot-scope="props">
                      <tr @click="prepareUpdateUniservice(props.item)">
                        <td style="font-size: 13px;">{{ props.item.sno }}</td>
                        <td style="font-size: 13px;">{{ props.item.category ? props.item.category : ' ' }}</td>
                        <td style="font-size: 13px;">{{ props.item.mi_uni_commit ? props.item.mi_uni_commit : ' ' }}</td>
                        <td style="font-size: 13px;">{{ props.item.mi_freq ? props.item.mi_freq : ' ' }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-container>

        <!-- Add or update Uniservice Commitments -->
        <v-dialog v-model="showUniserviceCommit" persistent max-width="500px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lForm" @submit.prevent="saveUniserviceCommitChanges(lUniCommit.action)">
                <v-card scrollable>
                  <v-card-title class="title grey lighten-4 py-2">
                    {{lUniCommit.action === 'create-uniComit' ? 'Create' : 'Update'}} Uniservice Commitment
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 class="pt-4">
                        <v-autocomplete
                        v-model="lUniCommit.category"
                        label="Category"
                        :items="['MANAGEMENT/OFFICE', 'TECHNICAL SERVICES', 'SOFT SERVICES', 'SAFTY/SECURITY', 'OTHERS']"
                        hide-details
                        dense
                        :rules="[rules.required]"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lUniCommit.mi_uni_commit"
                        label="Commitment Description"
                        hide-details
                        maxlength="250"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs8 class="pt-4">
                        <v-autocomplete
                        v-model="lUniCommit.mi_freq_id"
                        :items="freqItem"
                        item-value="mi_freq_id"
                        item-text="mi_freq"
                        label="Frequency"
                        dense
                        hide-details
                        :rules="[rules.required]"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs4 class="pt-4">
                        <v-btn small @click="loadListFrequency()">Add Frequency</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-btn v-if="lUniCommit.action !== 'create-uniComit' && (config.IS_EDITED_BY_USER)" @click="deleteUniserviceCommitChanges('delete-uniComit')">delete</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click.stop="showUniserviceCommit = false">Cancel</v-btn>
                    <v-btn type="submit" color="accent" v-if="(config.IS_EDITED_BY_USER)">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- Onboarding review config -->
        <v-container class="pa-0" v-if="lAction === 'onboarding'" grid-list-md>
          <v-flex xs12>
            <v-card>
              <v-card-title class="primary--text py-2 grey lighten-4">
                <v-btn class="mr-2" small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
                Onboarding Review Planner Configuration
              </v-card-title>
              <v-card-text class="pt-1">
                <v-expansion-panels class="pt-2" :value="selTab">
                  <v-expansion-panel class="pa-1" v-for="(cat, i) in onboardCat" :key="i">
                    <v-expansion-panel-header style="min-height: 42px" class="pt-2 grey lighten-4 font-weight-bold">
                      {{cat.mi_onb_cat + ' (' + cat.prior_days + ' days prior to project start date' +')'}}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="pt-2">
                      <v-flex xs12>
                        <v-data-table
                        :headers="onboardReviewPageHeader"
                        :items="onboardingReviewPageItem.filter(rec => rec.mi_onb_cat_id === cat.mi_onb_cat_id)"
                        disable-pagination
                        dense
                        hide-default-header
                        hide-default-footer
                        class="elevation-3"
                        :mobile-breakpoint="0">
                          <template v-slot:header="{ props: { headers } }">
                            <thead>
                              <tr>
                                <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 50px; text-align: left;">{{headers[0].text}}</th>
                                <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 400px; text-align: left;">{{headers[1].text}}</th>
                                <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 200px; text-align: center;">{{headers[2].text}}</th>
                                <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 200px; text-align: center;">{{headers[3].text}}</th>
                              </tr>
                            </thead>
                          </template>
                          <template slot="item" slot-scope="props">
                            <tr @click="prepareUpdateOnboardSubCat(props.item)">
                              <td style="font-size: 13px;">{{ props.item.sno }}</td>
                              <td style="font-size: 13px;">{{ props.item.mi_onb_sub_cat ? props.item.mi_onb_sub_cat : ' ' }}</td>
                              <td style="font-size: 13px;" class="text-center">{{ props.item.mi_is_onb_complete ? 'Yes' : 'No' }}</td>
                              <td style="font-size: 13px;" class="text-center">{{ props.item.mi_is_asset_recoverable ? 'Yes' : 'No' }}</td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-container>

        <!-- Add or update Onboard sub dategory -->
        <v-dialog v-model="showOnboard" persistent max-width="500px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lForm" @submit.prevent="saveOnboardChanges(lOnboard.action)">
                <v-card scrollable>
                  <v-card-title class="title grey lighten-4 py-2">
                    {{lOnboard.action === 'create-onboard-subcat' ? 'Create' : 'Update'}} Onboarding Planner
                    <v-spacer></v-spacer>
                    <v-btn icon small @click.stop="showOnboard = false"><v-icon>mdi-close</v-icon></v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-layout class="pt-3" row wrap>
                      <v-flex xs8>
                        <v-autocomplete
                        v-model="lOnboard.mi_onb_cat_id"
                        :items="onboardCat"
                        item-value="mi_onb_cat_id"
                        item-text="mi_onb_cat"
                        label="Onboarding planner Category"
                        dense
                        hide-details
                        :rules="[rules.required]"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs4 class="pt-1">
                        <v-btn small @click="showOnboardCat = true">Add Category</v-btn>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lOnboard.mi_onb_sub_cat"
                        label="Onboarding Planner Question"
                        hide-details
                        maxlength="100"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs6>
                            <v-checkbox hide-details
                            label="Is Completed by Onboarding?"
                            v-model="lOnboard.mi_is_onb_complete"
                            class="my-label-text-size"
                            >
                            </v-checkbox>
                          </v-flex>
                          <v-flex xs6>
                            <v-checkbox hide-details
                            label="Is Uniservice Asset?"
                            v-model="lOnboard.mi_is_asset_recoverable"
                            class="my-label-text-size"
                            >
                            </v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-btn v-if="lOnboard.action !== 'create-onboard-subcat' && (config.IS_EDITED_BY_USER)" @click="deleteOnboardChanges('delete-onboard-subcat')">delete</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn type="submit" color="accent" v-if="(config.IS_EDITED_BY_USER)">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- List of Onboarding Category -->
        <v-dialog v-model="showOnboardCat" persistent max-width="500px">
          <v-flex xs12>
            <v-card>
              <v-card-title class="grey lighten-4 py-2">
                Onboarding Planner Category
                <v-spacer></v-spacer>
                <v-btn icon small @click="showOnboardCat = false"><v-icon>mdi-close</v-icon></v-btn>
              </v-card-title>
              <v-card-text>
                <v-flex xs12 class="text-right py-2">
                  <v-btn small class="accent" @click="prepareOnboardCat()">Add New</v-btn>
                </v-flex>
                <v-data-table
                :headers="onboardCatHeader"
                :items="onboardCat"
                disable-pagination
                hide-default-footer
                dense
                class="elevation-3"
                :mobile-breakpoint="0">
                  <template slot="item" slot-scope="props">
                    <tr @click="updateOnboardCategory(props.item)">
                      <td style="font-size: 13px;">{{ props.item.mi_onb_cat ? props.item.mi_onb_cat : ' ' }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-dialog>

        <!-- Add or update onboard category -->
        <v-dialog v-model="showOnboardCateditorupdate" persistent max-width="500px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lForm" @submit.prevent="saveOnboardCatChanges(lOnboardCat.action)">
                <v-card scrollable>
                  <v-card-title class="title grey lighten-4 py-2">
                    {{lOnboardCat.action === 'create-onboard-cat' ? 'Create' : 'Update'}} Onboarding Planner Category
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lOnboardCat.mi_onb_cat"
                        label="Onboard Category"
                        hide-details
                        maxlength="100"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lOnboardCat.prior_days"
                        label="Prior Days"
                        hide-details
                        maxlength="100"
                        type="number"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-btn v-if="lOnboard.action !== 'create-onboard-cat' && (config.IS_EDITED_BY_USER)" @click="deleteOnboardCatChanges('delete-onboard-cat')">delete</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click.stop="showOnboardCateditorupdate = false">Cancel</v-btn>
                    <v-btn type="submit" color="accent" v-if="(config.IS_EDITED_BY_USER)">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- Resource responsibility config -->
        <v-container class="pa-0" v-if="lAction === 'resource'" grid-list-md>
          <v-flex xs12>
            <v-card>
              <v-card-title class="primary--text py-0 grey lighten-4">
                <v-btn class="mr-2" icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
                Resource Responsibility Configuration
              </v-card-title>
              <v-flex xs12 class="mt-3 pa-2">
                <v-card>
                  <v-card-title class="primary--text py-0 grey lighten-4">
                    Active Resources
                    <v-flex xs10 class="text-right" >
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" v-if="(config.IS_EDITED_BY_USER)" class="warning--text" icon small @click="prepareCreateResp()"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                        </template>
                        <span>Add New</span>
                      </v-tooltip>
                    </v-flex>
                  </v-card-title>
                  <v-card-text class="pt-3">
                    <v-flex xs12>
                      <v-data-table
                      :headers="resourceActiveHead"
                      :items="resourceRespActiveList"
                      disable-pagination
                      hide-default-header
                      hide-default-footer
                      class="elevation-3"
                      dense
                      :mobile-breakpoint="0">
                        <template v-slot:header="{ props: { headers } }">
                          <thead>
                            <tr>
                              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 50px; text-align: left;">{{headers[0].text}}</th>
                              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[1].text}}</th>
                              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[2].text}}</th>
                              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[3].text}}</th>
                              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[4].text}}</th>
                              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[5].text}}</th>
                              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[6].text}}</th>
                              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[7].text}}</th>
                            </tr>
                          </thead>
                        </template>
                        <template slot="item" slot-scope="props">
                          <tr>
                            <td style="font-size: 13px;">{{ props.index + 1 }}</td>
                            <td style="font-size: 13px;">{{ props.item.emp_id }}</td>
                            <td style="font-size: 13px;">{{ props.item.emp_name }}</td>
                            <td style="font-size: 13px;">{{ props.item.disp_short_name }}</td>
                            <td style="font-size: 13px;">{{ props.item.emp_desig }}</td>
                            <td style="font-size: 13px;">{{ props.item.emp_status }}</td>
                            <td style="font-size: 13px;">{{ props.item.mi_status }}</td>
                            <td v-if="(config.IS_EDITED_BY_USER)">
                              <v-btn icon small class="text-center"><v-icon small @click="prepareUpdateResp(props.item)">mdi-pencil</v-icon></v-btn>
                              <v-btn icon small class="text-center"><v-icon small @click="deleteResp(props.item)">mdi-delete</v-icon></v-btn>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 class="mt-1 pa-2">
                <v-card>
                  <v-card-title class="primary--text py-0 grey lighten-4">
                    In-Active Resources
                  </v-card-title>
                  <v-card-text class="pt-3">
                    <v-flex xs12>
                      <v-data-table
                      :headers="resourceInActiveHead"
                      :items="resourceRespInActiveList"
                      disable-pagination
                      hide-default-header
                      hide-default-footer
                      class="elevation-3"
                      dense
                      :mobile-breakpoint="0">
                        <template v-slot:header="{ props: { headers } }">
                          <thead>
                            <tr>
                              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 50px; text-align: left;">{{headers[0].text}}</th>
                              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[1].text}}</th>
                              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[2].text}}</th>
                              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[3].text}}</th>
                              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[4].text}}</th>
                              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[5].text}}</th>
                              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[6].text}}</th>
                              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[7].text}}</th>
                              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[8].text}}</th>
                            </tr>
                          </thead>
                        </template>
                        <template slot="item" slot-scope="props">
                          <tr>
                            <td style="font-size: 13px;">{{ props.index + 1 }}</td>
                            <td style="font-size: 13px;">{{ props.item.emp_id }}</td>
                            <td style="font-size: 13px;">{{ props.item.emp_name }}</td>
                            <td style="font-size: 13px;">{{ props.item.disp_short_name }}</td>
                            <td style="font-size: 13px;">{{ props.item.emp_desig }}</td>
                            <td style="font-size: 13px;">{{ props.item.in_active_dt ? handy.formatDBDate(props.item.in_active_dt) : '-' }}</td>
                            <td style="font-size: 13px;">{{ props.item.emp_status }}</td>
                            <td style="font-size: 13px;">{{ props.item.mi_status }}</td>
                            <td v-if="(config.IS_EDITED_BY_USER)">
                              <v-btn icon small class="text-center"><v-icon small @click="prepareUpdateResp(props.item)">mdi-pencil</v-icon></v-btn>
                              <v-btn icon small class="text-center"><v-icon small @click="deleteResp(props.item)">mdi-delete</v-icon></v-btn>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-card>
          </v-flex>
        </v-container>

        <!-- create resource responsibility -->
        <v-dialog v-model="showResourceResp" persistent max-width="650px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lForm" @submit.prevent="saveResourceResp(lResource.action)">
                <v-card scrollable>
                  <v-card-title class="title grey lighten-4 py-2">
                    {{lResource.action === 'create-resource' ? 'Add' : 'Update'}} Resource Details
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs6 class="pt-4">
                        <v-combobox
                        v-model="lResource.emp_pair"
                        label="Employee"
                        item-value="emp_id"
                        item-text="emp_name_with_id"
                        :items="showAllEmp ? empList : empList.filter(rec => rec.emp_status === 'On Job')"
                        :rules="[rules.required]"
                        dense
                        @input="loadEmpDet(lResource.emp_pair)"
                        ></v-combobox>
                      </v-flex>
                      <v-flex xs6 class="text-xs-right">
                        <v-switch
                        v-model="showAllEmp"
                        label="Show all employees"
                        class="my-label-text-size"
                        @change="$forceUpdate()"
                        ></v-switch>
                      </v-flex>
                      <v-flex v-if="lResource.emp_pair">
                        <v-layout row wrap>
                          <v-flex xs6>
                            <span class="caption grey--text">Employee Id.</span><br />
                            <span class="black--text">{{ empDet.emp_id }}</span>
                          </v-flex>
                          <v-flex xs6>
                            <span class="caption grey--text">Employee Name</span><br />
                            <span class="black--text">{{ empDet.emp_name }}</span>
                          </v-flex>
                          <v-flex xs6>
                            <span class="caption grey--text">Designation</span><br />
                            <span class="black--text">{{empDet.emp_desig}}</span>
                          </v-flex>
                          <v-flex xs6>
                            <span class="caption grey--text">Status</span><br />
                            <span class="black--text">{{empDet.emp_status}}</span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field
                        v-model="lResource.disp_short_name"
                        label="Display Short Name"
                        hide-details
                        maxlength="15"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-select
                        v-model="lResource.mi_status"
                        label="MI Status"
                        hide-details
                        :items="['Active', 'In-Active']"
                        ></v-select>
                      </v-flex>
                      <v-flex xs6 v-if="lResource.mi_status === 'In-Active'">
                        <v-dialog ref="dlgstartDt"
                        persistent v-model="dlgstartDt"
                        max-width="290px"
                        class="pt-0"
                        :return-value.sync="lResource.in_active_dt">
                          <template v-slot:activator="{ on }">
                            <v-text-field
                            slot="activator"
                            label="In-Active From"
                            v-model="lResource.in_active_dt" append-icon="mdi-calendar-today"
                            :rules="[rules.required]"
                            readonly
                            v-on="on"
                            hide-details
                            ></v-text-field>
                          </template>
                          <v-date-picker
                          v-model="lResource.in_active_dt"
                          scrollable
                          >
                            <div class="flex-grow-1"></div>
                            <v-btn text @click="dlgstartDt = false">Cancel</v-btn>
                            <v-btn text color="accent" @click="$refs.dlgstartDt.save(lResource.in_active_dt)">OK</v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                        v-model="lResource.remarks"
                        label="Remarks"
                        rows="2"
                        outlined
                        hide-details
                        maxlength="250"
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn @click.stop="showResourceResp = false">Cancel</v-btn>
                    <v-btn type="submit" color="accent">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- deboarding review config -->
        <v-container class="pa-0" v-if="lAction === 'deboarding'" grid-list-md>
          <v-flex xs12>
            <v-card>
              <v-card-title class="primary--text py-2 grey lighten-4">
                <v-btn class="mr-2" small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
                Deboarding Review Planner Configuration
              </v-card-title>
              <v-card-text class="pt-1">
                <v-expansion-panels class="pt-2" :value="selTab">
                  <v-expansion-panel class="pa-1" v-for="(cat, i) in deboardCat" :key="i">
                    <v-expansion-panel-header style="min-height: 42px" class="pt-2 grey lighten-4 font-weight-bold">
                      {{cat.mi_deboard_cat}}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="pt-2">
                      <v-flex xs12>
                        <v-data-table
                        :headers="deboardReviewPageHeader"
                        :items="deboardingReviewPageItem.filter(rec => rec.mi_deboard_cat_id === cat.mi_deboard_cat_id)"
                        disable-pagination
                        dense
                        hide-default-header
                        hide-default-footer
                        class="elevation-3"
                        :mobile-breakpoint="0">
                          <template v-slot:header="{ props: { headers } }">
                            <thead>
                              <tr>
                                <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 50px; text-align: left;">{{headers[0].text}}</th>
                                <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 400px; text-align: left;">{{headers[1].text}}</th>
                                <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 200px; text-align: left;">{{headers[2].text}}</th>
                              </tr>
                            </thead>
                          </template>
                          <template slot="item" slot-scope="props">
                            <tr @click="prepareUpdateDeboardSubCat(props.item)">
                              <td style="font-size: 13px;">{{ props.item.sno }}</td>
                              <td style="font-size: 13px;">{{ props.item.mi_deboard_sub_cat ? props.item.mi_deboard_sub_cat : ' ' }}</td>
                              <td style="font-size: 13px;">{{ props.item.prior_days }}</td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-container>

        <!-- Add or update Deboard sub dategory -->
        <v-dialog v-model="showDeboard" persistent max-width="500px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lForm" @submit.prevent="saveDeboardChanges(lDeboard.action)">
                <v-card scrollable>
                  <v-card-title class="title grey lighten-4 py-2">
                    {{lDeboard.action === 'create-deboard-subcat' ? 'Create' : 'Update'}} Deboarding Planner
                    <v-spacer></v-spacer>
                    <v-btn icon small @click.stop="showDeboard = false"><v-icon>mdi-close</v-icon></v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex class="pt-4" xs8>
                        <v-autocomplete
                        v-model="lDeboard.mi_deboard_cat_id"
                        :items="deboardCat"
                        item-value="mi_deboard_cat_id"
                        item-text="mi_deboard_cat"
                        label="Deboarding planner Category"
                        hide-details
                        dense
                        :rules="[rules.required]"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs4 class="pt-4">
                        <v-btn small @click="showDeboardCat = true">Add Category</v-btn>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lDeboard.mi_deboard_sub_cat"
                        label="Deboarding Planner Question"
                        hide-details
                        maxlength="100"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lDeboard.prior_days"
                        label="Prior Days"
                        hide-details
                        maxlength="100"
                        type="number"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-btn v-if="lDeboard.action !== 'create-deboard-subcat' && (config.IS_EDITED_BY_USER)" @click="deleteDeboardChanges('delete-deboard-subcat')">delete</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn type="submit" color="accent" v-if="(config.IS_EDITED_BY_USER)">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- List of Deboarding Category -->
        <v-dialog v-model="showDeboardCat" persistent max-width="500px">
          <v-flex xs12>
            <v-card>
              <v-card-title class="grey lighten-4 py-2">
                Deboarding Planner Category
                <v-spacer></v-spacer>
                <v-btn icon small @click="showDeboardCat = false"><v-icon>mdi-close</v-icon></v-btn>
              </v-card-title>
              <v-card-text>
                <v-flex xs12 class="text-right py-2">
                  <v-btn small class="accent" @click="prepareDeboardCat()">Add New</v-btn>
                </v-flex>
                <v-data-table
                :headers="deboardCatHeader"
                :items="deboardCat"
                disable-pagination
                hide-default-footer
                class="elevation-3"
                dense
                :mobile-breakpoint="0">
                <template slot="item" slot-scope="props">
                  <tr @click="updateDeboardCategory(props.item)">
                    <td style="font-size: 13px;">{{ props.item.mi_deboard_cat ? props.item.mi_deboard_cat : ' ' }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
        </v-dialog>

        <!-- Add or update deboard category -->
        <v-dialog v-model="showDeboardCateditorupdate" persistent max-width="500px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lForm" @submit.prevent="saveDeboardCatChanges(lDeboardCat.action)">
                <v-card scrollable>
                  <v-card-title class="title grey lighten-4 py-2">
                    {{lDeboardCat.action === 'create-deboard-cat' ? 'Create' : 'Update'}} Deboarding Planner Category
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lDeboardCat.mi_deboard_cat"
                        label="Deboard Category"
                        hide-details
                        maxlength="100"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-btn v-if="lDeboard.action !== 'create-deboard-cat' && (config.IS_EDITED_BY_USER)" @click="deleteDeboardCatChanges('delete-deboard-cat')">delete</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click.stop="showDeboardCateditorupdate = false">Cancel</v-btn>
                    <v-btn type="submit" color="accent" v-if="(config.IS_EDITED_BY_USER)">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- snack bar for reporting -->
        <v-snackbar :color="sbarCol" v-model="sbar"
        :timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default {
  data () {
    return {
      // common
      sbarMsg: '',
      sbarCol: 'error',
      sbar: false,
      config: config,
      lAction: 'view',
      handy: handy,
      rules: handy.rules,
      // sales
      selTab: 0,
      salesReviewPageItem: [],
      salesReviewPageHeader: [
        { text: 'S NO.', values: 'sno' },
        { text: 'Information/ Questionnaire', values: 'mi_sales_sub_cat' }
      ],
      showSales: false,
      lSales: [],
      showSalesCat: false,
      lSalesCat: [],
      salesCat: [],
      salesCatHeader: [
        { text: 'Sales Review Questionnaire', values: 'mi_sales_cat' }
      ],
      showSalesCateditorupdate: false,
      // voice of customer
      voiceOfCustomerItem: [],
      voiceOfCustomerHeader: [
        { text: 'SNo', values: 'sno' },
        { text: 'Questionnaire', values: 'mi_voice_of_cust' }
      ],
      lVoice: [],
      showVoice: false,
      // customer Expectations
      customerExpectationItem: [],
      customerExpectationHeader: [
        { text: 'SNo', values: 'sno' },
        { text: 'Category', values: 'category' },
        { text: 'Customer Expectation Description', values: 'mi_cust_expect' },
        { text: 'Frequency', values: 'mi_freq' }
      ],
      // customer expectation
      showCust: false,
      lCust: [],
      custFreqList: [],
      showListofCustFreq: false,
      lCustFreq: [],
      showCustFreq: false,
      freqHeader: [
        { text: 'Frequency', values: 'mi_freq' }
      ],
      freqItem: [],
      // Uniservice Commitment
      uniserviceCommitHeader: [
        { text: 'SNo', values: 'sno' },
        { text: 'Category', values: 'category' },
        { text: 'Commitment Description', values: 'mi_uni_commit' },
        { text: 'Frequency', values: 'mi_freq' }
      ],
      uniserviceCommitItem: [],
      showUniserviceCommit: false,
      lUniCommit: [],
      // onboarding
      onboardingReviewPageItem: [],
      lOnboard: '',
      showOnboard: false,
      onboardCat: [],
      showOnboardCateditorupdate: false,
      showOnboardCat: false,
      lOnboardCat: '',
      onboardCatHeader: [
        { text: 'Onboard Review Category List', values: 'mi_onb_cat' }
      ],
      onboardReviewPageHeader: [
        { text: 'S NO.', values: 'sno' },
        { text: 'Information/ Questionnaire', values: 'mi_onb_sub_cat' },
        { text: 'Complete By Onboarding?', values: 'mi_is_onb_complete' },
        { text: 'Recoverable Asset?', values: 'mi_is_asset_recoverable' }
      ],
      resourceActiveHead: [
        { text: 'SNo', values: 'sno' },
        { text: 'Employee Id', values: 'employee_id' },
        { text: 'Employee Name', values: 'emp_name' },
        { text: 'Short Name', values: 'disp_short_name' },
        { text: 'Designation', values: 'emp_desig' },
        { text: 'Employee Status', values: 'emp_status' },
        { text: 'Mi Status', values: 'mi_status' },
        { text: 'Action', value: '' }
      ],
      resourceInActiveHead: [
        { text: 'SNo', values: 'sno' },
        { text: 'Employee Id', values: 'employee_id' },
        { text: 'Employee Name', values: 'emp_name' },
        { text: 'Short Name', values: 'disp_short_name' },
        { text: 'Designation', values: 'emp_desig' },
        { text: 'In-Active From ', values: 'in_active_dt' },
        { text: 'Employee Status', values: 'emp_status' },
        { text: 'Mi Status', values: 'mi_status' },
        { text: 'Action', value: '' }
      ],
      resourceRespActiveList: [],
      resourceRespInActiveList: [],
      showResourceResp: false,
      showAllEmp: false,
      lResource: {},
      empList: [],
      dlgstartDt: false,
      empDet: [],
      resourceRespList: [],
      // deboarding
      deboardingReviewPageItem: [],
      deboardCat: [],
      lDeboard: '',
      showDeboard: false,
      showDeboardCat: false,
      lDeboardCat: '',
      deboardCatHeader: [
        { text: 'Deboard Review Category List', values: 'mi_deboard_cat' }
      ],
      showDeboardCateditorupdate: false,
      deboardReviewPageHeader: [
        { text: 'S NO.', values: 'sno' },
        { text: 'Information/ Questionnaire', values: 'mi_deboard_sub_cat' },
        { text: 'Prior Days', values: 'prior_days' }
      ],
    }
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadCatForSalesReviewPage () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getSalesCat/', qry)
      .then(response => {
        this.salesCat = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareCreateSales () {
      this.lSales = {
        mi_sales_cat_id: null,
        mi_sales_sub_cat: '',
        vendor_id: config.VENDOR_ID,
        action: 'create-sale-subcat'
      }
      this.showSales = true
    },
    prepareSalesCat () {
      this.lSalesCat = {
        mi_sales_cat: '',
        action: 'create-sale-cat'
      }
      this.showSalesCateditorupdate = true
    },
    saveSalesCatChanges (action) {
      if (this.lSalesCat.mi_sales_cat) {
        this.lSalesCat.vendor_id = config.VENDOR_ID
        this.axios.post(config.API_URL + '/miSalesBaseInfoConfig/' + action, this.lSalesCat)
        .then(response => {
          this.msg('Saved Successfully', 1)
          this.loadCatForSalesReviewPage()
          this.showSalesCateditorupdate = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please give category name', 0)
      }
    },
    saveSalesChanges (action) {
      if (this.lSales.mi_sales_cat_id && this.lSales.mi_sales_sub_cat) {
        this.axios.post(config.API_URL + '/miSalesBaseInfoConfig/' + action, this.lSales)
        .then(response => {
          this.msg('Saved Successfully', 1)
          this.loadCatSubCatForSalesReviewPage()
          this.showSales = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please fill the both fields', 0)
      }
    },
    loadCatSubCatForSalesReviewPage () {
      this.loadCatForSalesReviewPage()
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.salesReviewPageItem = []
      this.axios.get(config.API_URL + '/getCatSubCatForSalesReviewPage/', qry)
      .then(response => {
        var count = 0
        for (var i = 0; i < response.data.length; i++) {
          if (i > 0) {
            if (response.data[i].mi_sales_cat_id === response.data[i-1].mi_sales_cat_id) {
              this.salesReviewPageItem.push({
                sno: count+1,
                mi_sales_cat_id: response.data[i].mi_sales_cat_id,
                mi_sales_sub_cat: response.data[i].mi_sales_sub_cat,
                mi_sales_sub_cat_id: response.data[i].mi_sales_sub_cat_id
              })
              count++
            } else {
              count = 0
              this.salesReviewPageItem.push({
                sno: count+1,
                mi_sales_cat_id: response.data[i].mi_sales_cat_id,
                mi_sales_sub_cat: response.data[i].mi_sales_sub_cat,
                mi_sales_sub_cat_id: response.data[i].mi_sales_sub_cat_id
              })
              count++
            }
          } else {
            this.salesReviewPageItem.push({
              sno: count+1,
              mi_sales_cat_id: response.data[i].mi_sales_cat_id,
              mi_sales_sub_cat: response.data[i].mi_sales_sub_cat,
              mi_sales_sub_cat_id: response.data[i].mi_sales_sub_cat_id
            })
            count++
          }
        }
        this.lAction = 'sales'
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    updateSalesCategory (curRec) {
      this.lSalesCat = Object.assign({}, curRec)
      this.lSalesCat.action = 'update-sale-cat'
      this.showSalesCateditorupdate = true
    },
    prepareUpdateSalesSubCat (curRec) {
      this.lSales = Object.assign({}, curRec)
      this.lSales.vendor_id = config.VENDOR_ID
      this.lSales.action = 'update-sale-subcat'
      this.showSales = true
    },
    deleteSalesChanges (action) {
      if (!confirm('Sure, you want to delete the Information/Questioner with name "' + this.lSales.mi_sales_sub_cat + '"? ' )) {
        return
      }
      this.axios.post(config.API_URL + '/miSalesBaseInfoConfig/' + action, this.lSales)
      .then(response => {
        this.msg('Deleted Successfully', 1)
        this.loadCatSubCatForSalesReviewPage()
        this.showSales = false
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    deleteSalesCatChanges (action) {
      if (!confirm('Sure, you want to delete the Category with name "' + this.lSalesCat.mi_sales_cat + '"? ' )) {
        return
      }
      this.lSalesCat.vendor_id = config.VENDOR_ID
      this.axios.post(config.API_URL + '/miSalesBaseInfoConfig/' + action, this.lSalesCat)
      .then(response => {
        this.msg('Deleted Successfully', 1)
        this.loadCatForSalesReviewPage()
        this.showSalesCateditorupdate = false
      })
      .catch(err => {
        this.msg('Having reference in sub category', 0)
      })
    },
    loadVoiceOfCustomerConfig () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.voiceOfCustomerItem = []
      this.axios.get(config.API_URL + '/getVoiceOfCustomerConfig/', qry)
      .then(response => {
        for (var i = 0; i < response.data.length; i++) {
          this.voiceOfCustomerItem.push({
            sno: i+1,
            mi_voice_of_cust_id: response.data[i].mi_voice_of_cust_id,
            mi_voice_of_cust: response.data[i].mi_voice_of_cust,
            vendor_id: response.data[i].vendor_id
          })
        }
        this.lAction = 'voice-of-customer'
      })
      .catch(err => {
        this.msg(err, 0)
        this.voiceOfCustomerItem = []
      })
    },
    prepareCreateVoiceofCust () {
      this.lVoice = {
        mi_voice_of_cust: '',
        vendor_id: config.VENDOR_ID,
        action: 'create-voice'
      }
      this.showVoice = true
    },
    saveVoiceChanges (action) {
      if (this.lVoice.mi_voice_of_cust) {
        this.axios.post(config.API_URL + '/miVoiceofCustomerConfig/' + action, this.lVoice)
        .then(response => {
          this.msg('Saved Successfully', 1)
          this.loadVoiceOfCustomerConfig()
          this.showVoice = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please raise voice of cust questions', 0)
      }
    },
    prepareUpdateVoice (curRec) {
      this.lVoice = Object.assign({}, curRec)
      this.lVoice.action = 'update-voice'
      this.showVoice = true
    },
    deleteVoiceChanges (action) {
      if (!confirm('Sure, you want to delete the Voice of customer with name "' + this.lVoice.mi_voice_of_cust + '"? ' )) {
        return
      }
      this.lVoice.vendor_id = config.VENDOR_ID
      this.axios.post(config.API_URL + '/miVoiceofCustomerConfig/' + action, this.lVoice)
      .then(response => {
        this.msg('Deleted Successfully', 1)
        this.loadVoiceOfCustomerConfig()
        this.showVoice = false
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadListFrequency () {
      this.loadFrequency()
      this.showListofCustFreq = true
    },
    loadFrequency () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.freqItem = []
      this.axios.get(config.API_URL + '/getListOfFreqBasedonVendorId/', qry)
      .then(response => {
        this.freqItem = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareCreateFrequency () {
      this.lCustFreq = {
        mi_freq: '',
        vendor_id: config.VENDOR_ID,
        action: 'create-custFreq'
      }
      this.showCustFreq = true
    },
    saveFreqChanges (action) {
      if (this.lCustFreq.mi_freq) {
        this.axios.post(config.API_URL + '/miCustFreqConfig/' + action, this.lCustFreq)
        .then(response => {
          this.msg('Saved Successfully', 1)
          this.loadFrequency()
          this.showCustFreq = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please add frequency', 0)
      }
    },
    prepareUpdateFrequency (curRec) {
      this.lCustFreq = Object.assign({}, curRec)
      this.lCustFreq.action = 'update-custFreq'
      this.loadFrequency()
      this.showCustFreq = true
    },
    deleteFreqChanges (action) {
      if (!confirm('Sure, you want to delete the Frequency with name "' + this.lCustFreq.mi_freq + '"? ' )) {
        return
      }
      this.axios.post(config.API_URL + '/miCustFreqConfig/' + action, this.lCustFreq)
      .then(response => {
        this.msg('Deleted Successfully', 1)
        this.loadFrequency()
        this.showCustFreq = false
      })
      .catch(err => {
        this.msg('Having reference in sub category', 0)
      })
    },
    loadCustomerExpectationConfig () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.customerExpectationItem = []
      this.axios.get(config.API_URL + '/getCustomerExpectConfig/', qry)
      .then(response => {
        for (var i = 0; i < response.data.length; i++) {
          this.customerExpectationItem.push({
            sno: i+1,
            mi_cust_expect_id: response.data[i].mi_cust_expect_id,
            mi_freq_id: response.data[i].mi_freq_id,
            mi_freq: response.data[i].mi_freq,
            mi_cust_expect: response.data[i].mi_cust_expect,
            category: response.data[i].category,
            vendor_id: response.data[i].vendor_id
          })
        }
        this.lAction = 'customer-expectation'
      })
      .catch(err => {
        this.msg(err, 0)
        this.customerExpectationItem = []
      })
    },
    prepareCreateCustExpect () {
      this.lCust = {
        mi_freq_id: null,
        mi_cust_expect: '',
        category: '',
        vendor_id: config.VENDOR_ID,
        action: 'create-cust'
      }
      this.loadFrequency()
      this.showCust = true
    },
    saveCustChanges (action) {
      if (this.lCust.category && this.lCust.mi_freq_id) {
        this.lCust.vendor_id = config.VENDOR_ID
        this.axios.post(config.API_URL + '/miCustExpectConfig/' + action, this.lCust)
        .then(response => {
          this.msg('Saved Successfully', 1)
          this.loadCustomerExpectationConfig()
          this.showCust = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please select category and frequency', 0)
      }
    },
    prepareUpdateCust (curRec) {
      this.lCust = Object.assign({}, curRec)
      this.lCust.action = 'update-cust'
      this.loadFrequency()
      this.showCust = true
    },
    deleteCustChanges (action) {
      if (!confirm('Sure, you want to delete the Customer Expectations with name "' + this.lCust.mi_cust_expect + '"? ' )) {
        return
      }
      this.axios.post(config.API_URL + '/miCustExpectConfig/' + action, this.lCust)
      .then(response => {
        this.msg('Deleted Successfully', 1)
        this.loadCustomerExpectationConfig()
        this.showCust = false
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadUniserviceCommitmentsConfig () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.uniserviceCommitItem = []
      this.axios.get(config.API_URL + '/getUniserviceCommitmentsConfig/', qry)
      .then(response => {
        for (var i = 0; i < response.data.length; i++) {
          this.uniserviceCommitItem.push({
            sno: i+1,
            mi_uni_commit_id: response.data[i].mi_uni_commit_id,
            mi_freq_id: response.data[i].mi_freq_id,
            mi_freq: response.data[i].mi_freq,
            mi_uni_commit: response.data[i].mi_uni_commit,
            category: response.data[i].category,
            vendor_id: response.data[i].vendor_id
          })
        }
        this.lAction = 'uniservice-commit'
      })
      .catch(err => {
        this.msg(err, 0)
        this.uniserviceCommitItem = []
      })
    },
    prepareCreateUniCommit () {
      this.lUniCommit = {
        mi_freq_id: null,
        mi_uni_commit: '',
        category: '',
        vendor_id: config.VENDOR_ID,
        action: 'create-uniComit'
      }
      this.loadFrequency()
      this.showUniserviceCommit = true
    },
    saveUniserviceCommitChanges (action) {
      if (this.lUniCommit.category && this.lUniCommit.mi_freq_id) {
        this.lUniCommit.vendor_id = config.VENDOR_ID
        this.axios.post(config.API_URL + '/miUniCommitConfig/' + action, this.lUniCommit)
        .then(response => {
          this.msg('Saved Successfully', 1)
          this.loadUniserviceCommitmentsConfig()
          this.showUniserviceCommit = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please select category and frequency', 0)
      }
    },
    prepareUpdateUniservice (curRec) {
      this.lUniCommit = Object.assign({}, curRec)
      this.lUniCommit.action = 'update-uniComit'
      this.loadFrequency()
      this.showUniserviceCommit = true
    },
    deleteUniserviceCommitChanges (action) {
      if (!confirm('Sure, you want to delete the Uniservice Commitment with name "' + this.lUniCommit.mi_uni_commit + '"? ' )) {
        return
      }
      this.axios.post(config.API_URL + '/miUniCommitConfig/' + action, this.lUniCommit)
      .then(response => {
        this.msg('Deleted Successfully', 1)
        this.loadUniserviceCommitmentsConfig()
        this.showUniserviceCommit = false
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    // On-boarding review
    loadCatSubCatForOnboardingReviewPage () {
      this.loadCatForOnboardReviewPage()
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.onboardingReviewPageItem = []
      this.axios.get(config.API_URL + '/getMICatSubCatForOnboardingReviewPage/', qry)
      .then(response => {
        var count = 0
        for (var i = 0; i < response.data.length; i++) {
          if (i > 0) {
            if (response.data[i].mi_onb_cat_id === response.data[i-1].mi_onb_cat_id) {
              this.onboardingReviewPageItem.push({
                sno: count+1,
                mi_onb_cat_id: response.data[i].mi_onb_cat_id,
                mi_onb_sub_cat: response.data[i].mi_onb_sub_cat,
                mi_onb_sub_cat_id: response.data[i].mi_onb_sub_cat_id,
                mi_is_onb_complete: response.data[i].mi_is_onb_complete,
                mi_is_asset_recoverable: response.data[i].mi_is_asset_recoverable
              })
              count++
            } else {
              count = 0
              this.onboardingReviewPageItem.push({
                sno: count+1,
                mi_onb_cat_id: response.data[i].mi_onb_cat_id,
                mi_onb_sub_cat: response.data[i].mi_onb_sub_cat,
                mi_onb_sub_cat_id: response.data[i].mi_onb_sub_cat_id,
                mi_is_onb_complete: response.data[i].mi_is_onb_complete,
                mi_is_asset_recoverable: response.data[i].mi_is_asset_recoverable
              })
              count++
            }
          } else {
            this.onboardingReviewPageItem.push({
              sno: count+1,
              mi_onb_cat_id: response.data[i].mi_onb_cat_id,
              mi_onb_sub_cat: response.data[i].mi_onb_sub_cat,
              mi_onb_sub_cat_id: response.data[i].mi_onb_sub_cat_id,
              mi_is_onb_complete: response.data[i].mi_is_onb_complete,
              mi_is_asset_recoverable: response.data[i].mi_is_asset_recoverable
            })
            count++
          }
        }
        this.lAction = 'onboarding'
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadCatForOnboardReviewPage () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getMIOnboardCatConfig/', qry)
      .then(response => {
        this.onboardCat = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareCreateOnboarding () {
      this.lOnboard = {
        mi_onb_cat_id: null,
        mi_onb_sub_cat: '',
        mi_is_onb_complete: false,
        mi_is_asset_recoverable: false,
        action: 'create-onboard-subcat'
      }
      this.showOnboard = true
    },
    prepareOnboardCat () {
      this.lOnboardCat = {
        mi_onb_cat: '',
        action: 'create-onboard-cat'
      }
      this.showOnboardCateditorupdate = true
    },
    saveOnboardCatChanges (action) {
      if (this.lOnboardCat.mi_onb_cat && this.lOnboardCat.prior_days) {
        this.lOnboardCat.vendor_id = config.VENDOR_ID
        this.axios.post(config.API_URL + '/miOnboardPlannerConfig/' + action, this.lOnboardCat)
        .then(response => {
          this.msg('Saved Successfully', 1)
          this.loadCatForOnboardReviewPage()
          this.showOnboardCateditorupdate = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please fill the both fields', 0)
      }
    },
    saveOnboardChanges (action) {
      if (this.lOnboard.mi_onb_cat_id && this.lOnboard.mi_onb_sub_cat) {
        this.lOnboard.vendor_id = config.VENDOR_ID
        this.axios.post(config.API_URL + '/miOnboardPlannerConfig/' + action, this.lOnboard)
        .then(response => {
          this.msg('Saved Successfully', 1)
          this.loadCatSubCatForOnboardingReviewPage()
          this.showOnboard = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please add category and sub-category', 0)
      }
    },
    updateOnboardCategory (curRec) {
      this.lOnboardCat = Object.assign({}, curRec)
      this.lOnboardCat.action = 'update-onboard-cat'
      this.showOnboardCateditorupdate = true
    },
    deleteOnboardChanges (action) {
      if (!confirm('Sure, you want to delete the Information/Questioner with name "' + this.lOnboard.mi_onb_sub_cat + '"? ' )) {
        return
      }
      this.axios.post(config.API_URL + '/miOnboardPlannerConfig/' + action, this.lOnboard)
      .then(response => {
        this.msg('Deleted Successfully', 1)
        this.loadCatSubCatForOnboardingReviewPage()
        this.showOnboard = false
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    deleteOnboardCatChanges (action) {
      if (!confirm('Sure, you want to delete the Category with name "' + this.lOnboardCat.mi_onb_cat + '"? ' )) {
        return
      }
      this.lSalesCat.vendor_id = config.VENDOR_ID
      this.axios.post(config.API_URL + '/miOnboardPlannerConfig/' + action, this.lOnboardCat)
      .then(response => {
        this.msg('Deleted Successfully', 1)
        this.loadCatSubCatForOnboardingReviewPage()
        this.showOnboardCateditorupdate = false
      })
      .catch(err => {
        this.msg('Having reference in sub category', 0)
      })
    },
    prepareUpdateOnboardSubCat (curRec) {
      this.lOnboard = Object.assign({}, curRec)
      this.lOnboard.vendor_id = config.VENDOR_ID
      this.lOnboard.action = 'update-onboard-subcat'
      this.showOnboard = true
    },
    loadResourceResponsibilty () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getMIAllResponseList/', qry)
      .then(response => {
        this.resourceRespList = response.data
        this.resourceRespActiveList = this.resourceRespList.filter(rec => rec.mi_status === 'Active')
        this.resourceRespInActiveList = this.resourceRespList.filter(rec => rec.mi_status === 'In-Active')
      })
      .catch(err => {
        this.msg(err, 0)
      })
      this.lAction = 'resource'
    },
    prepareCreateResp () {
      this.lResource = {
        emp_pair: '',
        mi_status: 'Active',
        in_active_dt: null,
        disp_short_name: '',
        action: 'create-resource'
      }
      this.showResourceResp = true
      this.showAllEmp = false
      this.loadAllEmployeeList()
    },
    loadAllEmployeeList () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getMIAllEmployee/', qry)
      .then(response => {
        this.empList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadEmpDet (curEmp) {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          emp_id: curEmp.emp_id
        }
      }
      this.axios.get(config.API_URL + '/getMIAllEmployee/', qry)
      .then(response => {
        this.empDet = response.data[0]
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    saveResourceResp (action) {
      if (this.lResource.emp_pair && this.lResource.emp_pair.emp_id && this.lResource.disp_short_name)
      {
        if (this.lResource.mi_status === 'In-Active') {
          if (!this.lResource.in_active_dt) {
            this.msg('Please select in-active date', 0)
            return
          }
        }
        this.lResource.emp_id = this.lResource.emp_pair.emp_id
        this.lResource.disp_short_name = handy.startWithUpper(this.lResource.disp_short_name)
        this.lResource.vendor_id = config.VENDOR_ID
        this.axios.post(config.API_URL + '/miResourceResponsibleConfig/' + action, this.lResource)
        .then(response => {
          if (response.data === 'Employee is already exist') {
            this.msg('Employee is already exist', 0)
          } else if (response.data === 'Employee is already exist in in-active please make status as active') {
            this.msg('Employee is already exist in in-active please make status as active')
          } else {
            this.msg('Saved Successfully', 1)
            this.loadResourceResponsibilty()
            this.showResourceResp = false
          }
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please select employee and enter short name', 0)
        return
      }
    },
    prepareUpdateResp (curRec) {
      this.loadAllEmployeeList()
      this.loadEmpDet(curRec)
      this.lResource = Object.assign({}, curRec)
      this.lResource.emp_pair = {emp_id: this.lResource.emp_id, emp_name_with_id: this.lResource.emp_name_with_id }
      this.lResource.in_active_dt = this.lResource.in_active_dt ? handy.formatDBDate(this.lResource.in_active_dt) : null
      this.lResource.action = 'update-resource'
      this.showResourceResp = true
    },
    deleteResp (curRec) {
      if (!confirm('Sure, you want to delete the responsibility for this employee "' + curRec.emp_name_with_id + '"? ' )) {
        return
      }
      this.lResource.action = 'delete-resource'
      this.axios.post(config.API_URL + '/miResourceResponsibleConfig/' + this.lResource.action, curRec)
      .then(response => {
        this.msg('Deleted Successfully', 1)
        this.loadResourceResponsibilty()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    // Deboarding review
    loadCatSubCatForDeboardingReviewPage () {
      this.loadCatForDeboardReviewPage()
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.deboardingReviewPageItem = []
      this.axios.get(config.API_URL + '/getMICatSubCatForDeboardingReviewPage/', qry)
      .then(response => {
        var count = 0
        for (var i = 0; i < response.data.length; i++) {
          if (i > 0) {
            if (response.data[i].mi_deboard_cat_id === response.data[i-1].mi_deboard_cat_id) {
              this.deboardingReviewPageItem.push({
                sno: count+1,
                mi_deboard_cat_id: response.data[i].mi_deboard_cat_id,
                mi_deboard_sub_cat: response.data[i].mi_deboard_sub_cat,
                mi_deboard_sub_cat_id: response.data[i].mi_deboard_sub_cat_id,
                prior_days: response.data[i].prior_days
              })
              count++
            } else {
              count = 0
              this.deboardingReviewPageItem.push({
                sno: count+1,
                mi_deboard_cat_id: response.data[i].mi_deboard_cat_id,
                mi_deboard_sub_cat: response.data[i].mi_deboard_sub_cat,
                mi_deboard_sub_cat_id: response.data[i].mi_deboard_sub_cat_id,
                prior_days: response.data[i].prior_days
              })
              count++
            }
          } else {
            this.deboardingReviewPageItem.push({
              sno: count+1,
              mi_deboard_cat_id: response.data[i].mi_deboard_cat_id,
              mi_deboard_sub_cat: response.data[i].mi_deboard_sub_cat,
              mi_deboard_sub_cat_id: response.data[i].mi_deboard_sub_cat_id,
              prior_days: response.data[i].prior_days
            })
            count++
          }
        }
        this.lAction = 'deboarding'
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadCatForDeboardReviewPage () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getMIDeboardCatConfig/', qry)
      .then(response => {
        this.deboardCat = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareCreateDeboarding () {
      this.lDeboard = {
        mi_deboard_cat_id: null,
        mi_deboard_sub_cat: '',
        action: 'create-deboard-subcat'
      }
      this.showDeboard = true
    },
    saveDeboardChanges (action) {
      if (this.lDeboard.mi_deboard_cat_id && this.lDeboard.mi_deboard_sub_cat && this.lDeboard.prior_days) {
        this.lDeboard.vendor_id = config.VENDOR_ID
        this.axios.post(config.API_URL + '/miDeboardPlannerConfig/' + action, this.lDeboard)
        .then(response => {
          this.msg('Saved Successfully', 1)
          this.loadCatSubCatForDeboardingReviewPage()
          this.showDeboard = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please add category and sub-category', 0)
      }
    },
    prepareDeboardCat () {
      this.lDeboardCat = {
        mi_deboard_cat: '',
        action: 'create-deboard-cat'
      }
      this.showDeboardCateditorupdate = true
    },
    saveDeboardCatChanges (action) {
      if (this.lDeboardCat.mi_deboard_cat) {
        this.lDeboardCat.vendor_id = config.VENDOR_ID
        this.axios.post(config.API_URL + '/miDeboardPlannerConfig/' + action, this.lDeboardCat)
        .then(response => {
          this.msg('Saved Successfully', 1)
          this.loadCatForDeboardReviewPage()
          this.showDeboardCateditorupdate = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please create category', 0)
      }
    },
    prepareUpdateDeboardSubCat (curRec) {
      this.lDeboard = Object.assign({}, curRec)
      this.lDeboard.vendor_id = config.VENDOR_ID
      this.lDeboard.action = 'update-deboard-subcat'
      this.showDeboard = true
    },
    updateDeboardCategory (curRec) {
      this.lDeboardCat = Object.assign({}, curRec)
      this.lDeboardCat.action = 'update-deboard-cat'
      this.showDeboardCateditorupdate = true
    },
    deleteDeboardChanges (action) {
      if (!confirm('Sure, you want to delete the Information/Questioner with name "' + this.lDeboard.mi_deboard_sub_cat + '"? ' )) {
        return
      }
      this.axios.post(config.API_URL + '/miDeboardPlannerConfig/' + action, this.lDeboard)
      .then(response => {
        this.msg('Deleted Successfully', 1)
        this.loadCatSubCatForDeboardingReviewPage()
        this.showDeboard = false
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    deleteDeboardCatChanges (action) {
      if (!confirm('Sure, you want to delete the Category with name "' + this.lDeboardCat.mi_deboard_cat + '"? ' )) {
        return
      }
      this.lDeboardCat.vendor_id = config.VENDOR_ID
      this.axios.post(config.API_URL + '/miDeboardPlannerConfig/' + action, this.lDeboardCat)
      .then(response => {
        this.msg('Deleted Successfully', 1)
        this.loadCatSubCatForDeboardingReviewPage()
        this.showDeboardCateditorupdate = false
      })
      .catch(err => {
        this.msg('Having reference in sub category', 0)
      })
    }
  }
}
</script>

<style lang="scss">
.importtabletd.v-data-table td{
  font-weight:normal;
  font-size:12px !important;
}
.importtableth.v-data-table th{
  font-weight:bold;
  font-size:12px !important;
}
.my-label-text-size .v-label {
  font-size: 14px !important;
}
</style>
